import doRequest from '@/api/dssRequest';
import { translate } from '@/translation/native_translate';
import utility, { toCurrency } from '@/shared/utility';

export default class PickupFee {
  eventId = '';

  possible = true;
  price = 0.0;
  vatId = '';
  vatPercentage = 0.0;
  vatPrice = 0.0;
  minimumOrderValue = 0.0;
  freeTresholdInUse = false;
  freeTresholdOrderValue = 0.0;
  failureReason = '';

  constructor(eventId) {
    this.eventId = eventId;
  }

  init() {
    this.possible = true;
    this.price = 0.0;
    this.vatId = '';
    this.vatPercentage = 0.0;
    this.vatPrice = 0.0;
    this.minimumOrderValue = 0.0;
    this.freeTresholdInUse = false;
    this.freeTresholdOrderValue = 0.0;
    this.failureReason = '';
  }

  updateWithRawData(data) {
    this.init();

    if (data == null || Object.keys(data).length === 0) {
      return;
    }

    this.possible = data.Possible;
    this.price = parseFloat(data.Price);
    this.vatId = data.VatId;
    this.vatPercentage = parseFloat(data.VatPercentage);
    this.vatPrice = parseFloat(data.VatPrice);
    this.minimumOrderValue = parseFloat(data.MinimumOrderValue);
    this.freeTresholdInUse = data.FreeTresholdInUse;
    this.freeTresholdOrderValue = parseFloat(data.FreeTresholdOrderValue);
    this.failureReason = data.FailureReason;
  }

  load(reservations = {}, shoppingListId = '', subscriptionProducts = []) {
    if (!this.eventId) {
      return Promise.reject(new Error(`Invalid event id - [${this.eventId}]`));
    }

    const payload = {
      Reservations: reservations,
      ShoppingListId: shoppingListId,
      SubscriptionProducts: subscriptionProducts,
    };

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          this.possible = response.data.Possible;
          this.price = parseFloat(response.data.Price);
          this.vatId = response.data.VatId;
          this.vatPercentage = parseFloat(response.data.VatPercentage);
          this.vatPrice = parseFloat(response.data.VatPrice);
          this.minimumOrderValue = parseFloat(response.data.MinimumOrderValue);
          this.freeTresholdInUse = response.data.FreeTresholdInUse;
          this.freeTresholdOrderValue = parseFloat(
            response.data.FreeTresholdOrderValue
          );
          this.failureReason = response.data.FailureReason;

          resolve(response);
        },
        reject,
        'getPickupFee',
        this.eventId,
        payload
      );
    });
  }

  isPossible() {
    return this.possible;
  }

  alertText() {
    if (this.isPossible()) {
      return '';
    }

    if (this.failureReason === 'E_DEL_002') {
      // Minimum order value not reached
      return utility.sprintf(
        translate('PICKUP_MINIMUM_ORDER_VALUE_ALERT'),
        toCurrency(this.minimumOrderValue)
      );
    }

    // Generic error message
    return translate('PICKUP_NOT_POSSIBLE');
  }

  hasPrice() {
    return this.price > 0;
  }

  priceText() {
    if (!this.hasPrice()) {
      return '';
    }

    return utility.sprintf(
      translate('PICKUP_FEE_INFO'),
      toCurrency(this.price)
    );
  }

  orderValueInfoText() {
    let result = '';

    if (this.minimumOrderValue > 0) {
      result += utility.sprintf(
        translate('MINIMUM_ORDER_VALUE_TEMP'),
        toCurrency(this.minimumOrderValue)
      );
    }

    if (this.freeTresholdInUse && this.freeTresholdOrderValue > 0) {
      if (result) {
        result += '. ';
      }

      result += utility.sprintf(
        translate('PICKUP_FREE_ORDER_VALUE'),
        toCurrency(this.freeTresholdOrderValue)
      );
    }

    return result;
  }
}
